import { render, staticRenderFns } from "./SttrD_Details.vue?vue&type=template&id=a3be6520"
import script from "./SttrD_Details.vue?vue&type=script&lang=js"
export * from "./SttrD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports